import VnrLink from '@components/VnrLink';
import React from 'react';

import styles from "./Breadcrumb.module.scss";

const BreadcrumbPageCategory = ({ categories = [], translate}) => {
  // Handle empty state early
  if (!categories || categories.length === 0) {
    return (
      <div className={styles.vnrBreadcrumb}>
        <VnrLink href="/">
          <span className={styles.breadcrumbItem}>
            {translate.layout.breadcrumb}
          </span>
        </VnrLink>
      </div>
    );
  };

  const getBreadcrumbTypo = (category) =>
    <span className={styles.breadcrumbItem} dangerouslySetInnerHTML={{ __html: `${category.name}` }} />

  return (
    <div className={styles.vnrBreadcrumb}>
      <VnrLink href={"/"}>
        <span className={styles.breadcrumbItem}>
          {translate.layout.breadcrumb}
        </span>
      </VnrLink>
      {categories.map((category, index) => (
        <span key={`post_category_${index}`}>
          {/* Breadcrumb separator */}
          &nbsp;»&nbsp;
          {index === categories.length - 1 ? (
            getBreadcrumbTypo(category)
          ) : (
            <VnrLink to={category.url || ""}>
              {getBreadcrumbTypo(category)}
            </VnrLink>
          )}
        </span>
      ))}
    </div>
  );
};
export default BreadcrumbPageCategory;
